import React from 'react';
import './clients.scss';

import { graphql, useStaticQuery } from 'gatsby';
import CompanyLetters from '../images/svg/socialnet-letters.svg';
import mapQueryResponse from '../utils/mapQueryResponse';
import { getImageUrl } from '../utils/helpers';

function Clients() {
  const data = useStaticQuery(graphql`
    query {
      strapi {
        clients {
          data {
            attributes {
              name
              image {
                ...Image
              }
            }
          }
        }
      }
    }
  `);

  const { strapi: queryData } = mapQueryResponse(data);
  return (
    <section className='bg-primary w-full lg:pt-36 lg:pb-24 lg:px-16 px-12 relative'>
      <div className='relative flex flex-col justify-end lg:mt-36'>
        <div className='text-6xl lg:text-[200px] font-bold text-[rgba(217,_217,_217,_0.37)] lg:absolute bottom-0 left-0'>
          socialnet
        </div>
        <div className='md:text-center text-5xl font-bold text-white relative w-full text-end'>
          partners
        </div>
      </div>
      <div className='grid grid-cols-3 gap-4 lg:gap-6 justify-center justify-items-center mt-14 lg:px-16 px-12'>
        {queryData.clients.map((client) => (
          <img
            alt={client.name}
            src={getImageUrl(client.image.hash)}
            className='lg:w-44 lg:h-44 w-24 h-24 col-span-1 object-scale-down'
          />
        ))}
      </div>
    </section>
  );
}

export default Clients;
